import React from 'react';
import { AppBar, Toolbar, Typography, Button, Menu, MenuItem, IconButton, Stack } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {AccountCircle,Home} from '@mui/icons-material'; // Profile icon
import { useSelector } from 'react-redux'; // To get profile name from Redux
import './AdminNavbar.css'; // Unique admin navbar styles
import LanguageToggle from '../../LanguageToggle/LanguageToggle';

const AdminNavbar = () => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [coursesAnchorEl, setCoursesAnchorEl] = useState(null);  // State for Courses menu
    const [userAnchorEl, setUserAnchorEl] = useState(null);
    const navigate = useNavigate();
    
    const profileName = useSelector(state => state.auth.user.profileName); // Get profile name from Redux
    
    // Handle dropdown for Users menu
    const handleUsersMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    
    const handleUsersMenuClose = () => {
        setAnchorEl(null);
    };

       // Handle dropdown for Courses menu
       const handleCoursesMenuClick = (event) => {
        setCoursesAnchorEl(event.currentTarget);
    };

    const handleCoursesMenuClose = () => {
        setCoursesAnchorEl(null);
    };
    
    // Handle dropdown for profile/account menu
    const handleProfileMenuClick = (event) => {
        setUserAnchorEl(event.currentTarget);
    };
    
    const handleProfileMenuClose = () => {
        setUserAnchorEl(null);
    };
  // Navigate to Admin Dashboard when clicking on Admin Panel title
  const handleAdminPanelClick = () => {
    navigate('/dashboard'); // Replace with the correct route for your Admin dashboard
};
    return (
        <AppBar position="static" className="admin-navbar">
            <Toolbar sx={{ gap: 1, flexWrap: 'wrap' }}>
                 {/* Make the Admin Panel title clickable */}
                <Typography
                    variant="h6"
                    className="admin-navbar-title"
                    sx={{ flexGrow: 1, cursor: 'pointer' }} // Add cursor style to indicate it's clickable
                    onClick={handleAdminPanelClick} // Add onClick handler to navigate to Admin dashboard
                >
                    Admin Panel
                </Typography>

                <Stack spacing={0.25} alignItems="flex-end" sx={{ mr: { xs: 0, md: 1.5 } }}>
                    <LanguageToggle size="small" />
                    <Typography variant="caption" color="inherit" align="right">
                        Please use English for now. Deutsch: Bitte derzeit auf Englisch arbeiten.
                    </Typography>
                </Stack>

                <Button color="inherit" onClick={() => navigate('/')}>
                 <Home />
                </Button>
                {/* Dropdown for Users */}
                <Button color="inherit" onClick={handleUsersMenuClick}>
                    Users
                </Button>
                <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleUsersMenuClose}
                >
                    <MenuItem onClick={() => { navigate('/dashboard/students'); handleUsersMenuClose(); }}>
                        Students
                    </MenuItem>
                    <MenuItem onClick={() => { navigate('/dashboard/teachers'); handleUsersMenuClose(); }}>
                        Teachers
                    </MenuItem>
                    <MenuItem onClick={() => { navigate('/dashboard/teacher-credentials'); handleUsersMenuClose(); }}>
                        Teacher Credential Export
                    </MenuItem>
                    <MenuItem onClick={() => { navigate('/dashboard/teacher-feedbacks'); handleUsersMenuClose(); }}>
                        Teacher Feedbacks
                    </MenuItem>
                    {useSelector((s) => s.auth.user.roleNames)?.includes("ADMIN_DEVELOPER") && (
                        <MenuItem onClick={() => { navigate('/dashboard/manage-all-users'); handleUsersMenuClose(); }}>
                            Manage All Users
                        </MenuItem>
                    )}
                </Menu>

  {/* Dropdown for Courses */}
  <Button color="inherit" onClick={handleCoursesMenuClick}>
                    Courses
                </Button>
                <Menu
                    anchorEl={coursesAnchorEl}
                    open={Boolean(coursesAnchorEl)}
                    onClose={handleCoursesMenuClose}
                >
                    <MenuItem onClick={() => { navigate('/dashboard/courses/pending'); handleCoursesMenuClose(); }}>
                        Pending Courses
                    </MenuItem>
                    <MenuItem onClick={() => { navigate('/dashboard/courses/approvals'); handleCoursesMenuClose(); }}>
                        Approvals
                    </MenuItem>
                    <MenuItem onClick={() => { 
                            navigate('/dashboard/students-courses-requested'); 
                            handleCoursesMenuClose(); 
                            }}>
                            Student Course Requests
                    </MenuItem>
                    <MenuItem onClick={() => { navigate('/dashboard/course-interests'); handleCoursesMenuClose(); }}>
                        Course Interest Offerings
                    </MenuItem>
                    <MenuItem onClick={() => { navigate('/dashboard/customize-conversation-courses'); handleCoursesMenuClose(); }}>
                        Customize Konversation &amp; Grammatik Courses
                    </MenuItem>
                    <MenuItem onClick={() => { navigate('/dashboard/payments/bank-transfer'); handleCoursesMenuClose(); }}>
                        Bank Transfer Payments
                    </MenuItem>
                    <MenuItem onClick={() => { navigate('/dashboard/payments'); handleCoursesMenuClose(); }}>
                        Payment Tracking
                    </MenuItem>
                    <MenuItem onClick={() => { navigate('/dashboard/payments/online'); handleCoursesMenuClose(); }}>
                        Online Payment History
                    </MenuItem>

                    {/* 🆕 Only show for ADMIN_DEVELOPER */}
                    {useSelector((s) => s.auth.user.roleNames)?.includes("ADMIN_DEVELOPER") && (
                        <>
                            <MenuItem onClick={() => { navigate('/dashboard/teacher-course-manager'); handleCoursesMenuClose(); }}>
                                Teacher Course Manager
                            </MenuItem>
                            <MenuItem onClick={() => { navigate('/dashboard/student-course-manager'); handleCoursesMenuClose(); }}>
                                Student Course Manager
                            </MenuItem>
                        </>
                    )}

                </Menu>

                <Button color="inherit" onClick={() => navigate('/dashboard/events')}>
                    Events
                </Button>

                <Button color="inherit" onClick={() => navigate('/dashboard/ausbildung-management')}>
                    Ausbildung
                </Button>
                {useSelector((s) => s.auth.user.roleNames)?.some(role => ["ADMIN", "ADMIN_DEVELOPER"].includes(role?.toUpperCase())) && (
                    <Button color="inherit" onClick={() => navigate('/dashboard/ausbildung/unlinked-applications')}>
                        Unlinked Applications
                    </Button>
                )}

                <Button color="inherit" onClick={() => navigate('/dashboard/consultant/employer-inquiries')}>
                    Employer Inquiries
                </Button>

                <Button color="inherit" onClick={() => navigate('/dashboard/site-feedback')}>
                    Feedback & Support
                </Button>

                <Button color="inherit" onClick={() => navigate('/settings')}>
                    Settings
                </Button>

                {/* Profile Menu */}
                <IconButton
                    color="inherit"
                    onClick={handleProfileMenuClick}
                    size="large"
                >
                    <AccountCircle />
                </IconButton>
                <Menu
                    anchorEl={userAnchorEl}
                    open={Boolean(userAnchorEl)}
                    onClose={handleProfileMenuClose}
                >
                    <MenuItem>
                        {profileName ? profileName : "Profile"}
                    </MenuItem>
                    <MenuItem onClick={() => navigate('/logout')}>Logout</MenuItem>
                </Menu>
            </Toolbar>
        </AppBar>
    );
};

export default AdminNavbar;
